import { render } from "./PAddFavorites.vue?vue&type=template&id=766e082e"
import script from "./PAddFavorites.vue?vue&type=script&lang=js"
export * from "./PAddFavorites.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__